import { cn } from '@/lib/utils'
import { effectMeta } from '../effect-vocab'

/**
 * The one way an effect is rendered anywhere in the app — icon, colour and
 * label all come from `effect-vocab`, so a "Relaxed" chip looks identical in
 * the product editor, a hover card and the POS.
 */
export function EffectChip({
  value,
  active = true,
  className,
}: {
  value: string
  /** Inactive chips (unpicked options) drop the tint and mute the icon. */
  active?: boolean
  className?: string
}) {
  const { label, icon: Icon, color, chip } = effectMeta(value)
  return (
    <span
      className={cn(
        'inline-flex h-7 select-none items-center gap-1.5 rounded-full border px-2.5 text-xs',
        active ? chip : 'border-border bg-background',
        className,
      )}
    >
      <Icon
        className={cn('h-3.5 w-3.5 shrink-0', active ? color : 'text-muted-foreground')}
        strokeWidth={2}
        aria-hidden="true"
      />
      <span className={active ? undefined : 'text-muted-foreground'}>{label}</span>
    </span>
  )
}
